import ApplicationContainer from "./views/container";
import EventRegisterView from "./views/event-register";
import InterviewFeedback from "./views/interview-feedback";
import MatchesView from "./views/matches";
import ProfileContainer from "./views/profile";
import ProgramRegisterView from "./views/program-register";
import auth from "./components/auth";

export default {
    ApplicationContainer,
    EventRegisterView,
    InterviewFeedback,
    MatchesView,
    ProfileContainer,
    ProgramRegisterView,
    SetPasswordView: auth.SetPasswordView,
};
